// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerLink":"Footer_footerLink__zoJJ6","year":"Footer_year__KivGH"};